import ProjectData from "@/data/ProjectData.ts";

const findIt3DProject = new ProjectData(
  "project-2",
  "Find It 3D",
  "img/projects/FindIt3D/findit3d4.png",
  `
    <div class="paragraph">
        <strong>Find It 3D</strong> - A 3D hidden object game where you hunt for items in messy rooms.
        <br/>Test your eagle eyes in realistic 3D environments that get trickier as you progress!
    </div>
    
    <div class="paragraph center">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/Jytkb-1bJZ8" 
                title="Find It 3D Gameplay" frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen style="border-radius: 8px; margin: 1rem 0;">
        </iframe>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/FindIt3D/findit3d1.png" alt="Find It 3D Gameplay Screenshot" />
    </div>
    <div class="paragraph center">
        <a href="https://tonkin.itch.io/find-it-3d" target="_blank"><img src="img/itchiologo.svg" alt="Available on itch.io" class="platform-logo" /></a>
    </div>

    <div class="paragraph">
        <strong>Cool Features I Added:</strong>
        <ul>
        <li>🎮 <strong>3D Environment Design:</strong> Built detailed rooms with objects scattered everywhere - had to balance making it challenging but not impossible</li>
        <li>🔄 <strong>Room Rotation System:</strong> Players can spin the camera around to see behind furniture and under tables - really opens up the search space</li>
        <li>💡 <strong>Dynamic Lighting:</strong> Added realistic shadows and lighting effects that change as you rotate - some items are only visible from certain angles!</li>
        <li>🔍 <strong>Smart Object Detection:</strong> Used raycasting so clicking on objects feels responsive and accurate</li>
        <li>📊 <strong>Player Analytics:</strong> Integrated Firebase to track which items are hardest to find and how long levels take - helps me tune the difficulty</li>
        </ul>
    </div>
    
    <div class="paragraph">
        <div class="notice">
        <strong>Try it out:</strong> Available on itch.io! See if you can find all the hidden objects before time runs out.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/FindIt3D/findit3d2.png" alt="Find It 3D Level 1" />
        <img class="pc-screenshot" src="img/projects/FindIt3D/findit3d3.png" alt="Find It 3D Level 2" />
        <img class="pc-screenshot" src="img/projects/FindIt3D/findit3d1.png" alt="Find It 3D User Interface" />
    </div>
    `,
  "#4a90e2",
  false
);

export default findIt3DProject;
